import { enqueueSnackbar } from 'notistack';
import { request } from '../../../network';
import { VerifyEmailParams } from '../types';

export enum VerifyEmailResult {
  EMAIL_ALREADY_VERIFIED = 'Email already verified',
  EMAIL_VERIFIED = 'Email verified',
}

export const verifyEmail = async (params: VerifyEmailParams): Promise<any> => {
  const response = await request({
    path: '/api/verify_email/',
    method: 'POST',
    body: { ...params },
    withAuth: false,
    silent: true,
  });

  if (response.ok) {
    return VerifyEmailResult.EMAIL_VERIFIED;
  }

  const error = new Error(response.errorMessage);

  // if email already verified, we should not show any error
  // just tell the user that their email is already verified
  if (error.message === 'Email already verified') {
    enqueueSnackbar(error.message, {
      variant: 'info',
    });
    return VerifyEmailResult.EMAIL_ALREADY_VERIFIED;
  }

  throw new Error(response.errorMessage);
};
